import { render, staticRenderFns } from "./CsvUpload.vue?vue&type=template&id=63ae33de&scoped=true&"
import script from "./CsvUpload.vue?vue&type=script&lang=js&"
export * from "./CsvUpload.vue?vue&type=script&lang=js&"
import style0 from "./CsvUpload.vue?vue&type=style&index=0&id=63ae33de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ae33de",
  null
  
)

export default component.exports